<template>
  <div>
    <slot
      :didOpen="didOpen"
      name="modal__button"
    >
      <div class="modal__button"></div>
    </slot>
    <portal to="modals">
      <Transition>
        <div class="duration-300 absolute bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center" v-show="modalOpen">
          <!--
            Background overlay, show/hide based on modal state.

            Entering: "ease-out duration-300"
              From: "opacity-0"
              To: "opacity-100"
            Leaving: "ease-in duration-200"
              From: "opacity-100"
              To: "opacity-0"
          -->
          <Transition
            enter-class="opacity-0"
            enter-to-class="opacity-100"
            leave-class="opacity-100"
            leave-to-class="opacity-0"
          >
            <div class="ease-out duration-300 fixed inset-0 transition-opacity" v-show="modalOpen" @click="didClose">
              <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>
          </Transition>

          <!--
            Modal panel, show/hide based on modal state.

            Entering: "ease-out duration-300"
              From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              To: "opacity-100 translate-y-0 sm:scale-100"
            Leaving: "ease-in duration-200"
              From: "opacity-100 translate-y-0 sm:scale-100"
              To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          -->
          <Transition
            enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-active-class="ease-out duration-300"
            enter-to-class="opacity-100 translate-y-0 sm:scale-100"
            leave-class="opacity-100 translate-y-0 sm:scale-100"
            leave-active-class="ease-in duration-200"
            leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div
              class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-headline"
              v-show="modalOpen"
            >
              <slot
                name="modal__body"
                :didClose="didClose"
              >
              </slot>
            </div>

          </Transition>

        </div>
      </Transition>
    </portal>
  </div>
</template>

<script>
export default {
  data () {
    return {
      modalOpen: false
    }
  },

  methods: {
    didOpen () {
      this.modalOpen = true
    },

    didClose () {
      this.modalOpen = false
    }
  },

  watch: {
    // modalOpen: {
    //   immediate: true,
    //   handler: show => {
    //     if (show) {
    //       document.body.style.setProperty("overflow", "hidden")
    //     } else {
    //       document.body.style.removeProperty("overflow")
    //     }
    //   }
    // }
  },
}
</script>
